import { type HTMLAttributes } from 'react';

import { cn } from '@/lib/utils';

export type ProgressGoalProps = HTMLAttributes<HTMLDivElement> & {
  value: number;
  shouldAnimate?: boolean;
};

const ProgressGoal = ({
  className,
  style,
  value,
  shouldAnimate = false,
  ...props
}: ProgressGoalProps) => {
  const boundedValue = Number.isFinite(value) ? Math.min(Math.max(value, 0), 100) : 0;

  return (
    <div
      className={cn(
        'absolute top-0 h-full transition-[left] duration-1000 ease-in-out',
        !shouldAnimate && 'transition-none',
        className,
      )}
      style={{ ...style, left: `${boundedValue}%` }}
      {...props}
    />
  );
};

export default ProgressGoal;
